module.exports = __webpack_public_path__ + "img/p_semerdzhiev.e5c96c12.jpg";